var map = {
	"./admin-user": 4,
	"./admin-user.jpg": 4,
	"./businessCard": 5,
	"./businessCard.jpg": 5,
	"./fake/001": 6,
	"./fake/001.jpg": 6,
	"./fake/002": 7,
	"./fake/002.jpg": 7,
	"./fake/003": 8,
	"./fake/003.jpg": 8,
	"./fake/004": 9,
	"./fake/004.jpg": 9,
	"./fake/005": 10,
	"./fake/005.jpg": 10,
	"./fake/006": 11,
	"./fake/006.jpg": 11,
	"./fake/007": 12,
	"./fake/007.jpg": 12,
	"./fake/008": 13,
	"./fake/008.jpg": 13,
	"./favicon.ico": 34,
	"./logo": 14,
	"./logo.png": 14,
	"./new-business-card": 15,
	"./new-business-card.jpg": 15,
	"./new-share-icon": 16,
	"./new-share-icon.png": 16,
	"./new-watermark": 17,
	"./new-watermark.png": 17,
	"./qr-code-share": 18,
	"./qr-code-share.png": 18,
	"./share-icon": 19,
	"./share-icon-origin": 20,
	"./share-icon-origin.png": 20,
	"./share-icon.png": 19,
	"./video_page": 21,
	"./video_page.jpeg": 21,
	"./watermark": 22,
	"./watermark-origin": 23,
	"./watermark-origin.png": 23,
	"./watermark.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;